import { useEffect } from 'react';

import {
  useLoginRecordsActions
} from './LoginRecordsContext';

import {
  getLoginRecords,
} from './restApi';

const LoginRecordsLoader = () => {
  const { initializeState, onResponse, onError } = useLoginRecordsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getLoginRecords({
      onResponse,
      onError,
      pageNumber: 1,
    });
  }, []);

  return null;
};

export default LoginRecordsLoader;
